module.exports = __webpack_public_path__ + "img/aviq.52a9c1ab.png";